<template>
  <base-list-item class="spin-library-event-list-item">
    <p class="left">{{ event.title }}</p>
    <p>{{ eventDate }}</p>
    <p class="right">{{ formsCount }} forms</p>
  </base-list-item>
</template>
<script>
import { formatDate } from "@/Helpers/invoice.js";
import BaseListItem from "../BaseListItem.vue";
export default {
  data() {
    return {};
  },
  computed: {
    eventDate() {
      switch (this.event.api_version) {
        case "9-28-2022":
          return formatDate(this.event.date);
        default:
          return formatDate(this.event.data.date);
      }
    },
    formsCount() {
      return this.event.forms.length;
    },
  },
  methods: {},
  created() {},
  components: {
    BaseListItem,
  },
  props: ["event"],
};
</script>
<style scoped>
.spin-library-event-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 10px;
}

p {
  font-size: 0.75em;
  width: 30%;
}

p.left {
  text-align: left;
}

p.right {
  text-align: right;
}
</style>
